var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "about" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", {
        style: {
          height: _vm.height,
          width: _vm.width,
          background: _vm.background,
        },
        attrs: { id: "leftUp" },
      }),
      _c("div", {
        style: {
          height: _vm.height,
          width: _vm.width,
          background: _vm.background,
        },
        attrs: { id: "rightUp" },
      }),
    ]),
    _c("div", { staticClass: "row" }, [
      _c("div", {
        style: {
          height: _vm.height,
          width: _vm.width,
          background: _vm.background,
        },
        attrs: { id: "leftBottom" },
      }),
      _c("div", {
        style: {
          height: _vm.height,
          width: _vm.width,
          background: _vm.background,
        },
        attrs: { id: "rightBottom" },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }